import React, { useState } from 'react'
import { navigate } from 'gatsby'
import clsx from 'clsx'
import kebabCase from 'lodash.kebabcase'

import { ListWithText } from '@/components/atoms/ListWithText/ListWithText'
import { ListWithBool } from '@/components/atoms/ListWithBool/ListWithBool'
import { ListWithTooltip } from '@/components/atoms/ListWithTooltip/ListWithTooltip'
import { Button } from '@/components/atoms/Button/Button'
import { getUrl } from '@/helpers/getUrl'
import { FeaturesTableTypes } from './types'
import * as styles from './FeaturesTableSection.module.css'

export function FeaturesTableSection({ title, tables, show_buttons, buttons }: FeaturesTableTypes) {
  const [tableVisibility, setTableVisibility] = useState(2)

  return (
    <section
      className="flex flex-col max-w-screen-laptop mx-auto py-24 tablet:px-90 tablet:py-64"
      id={kebabCase(title)}
    >
      <h2 className="font-poppins text-headingM-mobile tablet:text-headingM font-bold text-text-dark-900 mb-48 tablet:mb-26 text-center">
        {title}
      </h2>

      <div className="flex flex-col tablet:hidden">
        <div className="flex justify-center space-x-72 text-bodyL">
          {tables[2] && tables[2].title && (
            <Button
              type="button"
              as_form={false}
              _uid={`table-title-btn-${tableVisibility}`}
              url={{ cached_url: '', id: 'table_title', url: '', fieldtype: 'multilink', linktype: '' }}
              className={clsx(
                tableVisibility === 2 && 'font-poppins font-bold text-primary-500 border-b-4',
                styles.outline
              )}
              onClick={() => setTableVisibility(2)}
            >
              {tables[2].title}
            </Button>
          )}
          {tables[3] && tables[3].title && (
            <Button
              type="button"
              as_form={false}
              _uid={`table-title-btn-${tableVisibility}`}
              url={{ cached_url: '', id: 'table_title', url: '', fieldtype: 'multilink', linktype: '' }}
              className={clsx(
                tableVisibility === 3 && 'font-poppins font-bold text-primary-500 border-b-4',
                styles.outline
              )}
              onClick={() => setTableVisibility(3)}
            >
              {tables[3].title}
            </Button>
          )}
        </div>
        <div className="flex items-center flex-col">
          <div className="flex mb-28 w-full">
            <ListWithText list_items={tables[0]?.list_items} />
            <ListWithBool list_items={tables[tableVisibility]?.list_items} />
          </div>
          {show_buttons && buttons?.length > 0 && (
            <div className="w-full px-48">
              <Button {...buttons[0]} className="w-full h-64 px-48" onClick={() => navigate(getUrl(buttons[0].url))}>
                {buttons[0].text}
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className="hidden tablet:flex tablet:flex-col tablet:justify-center">
        <div className="flex justify-center mb-28">
          <ListWithText list_items={tables[0]?.list_items} />
          <ListWithTooltip list_items={tables[1]?.list_items} />
          <ListWithBool list_items={tables[2]?.list_items} />
          {tables[3] && <ListWithBool list_items={tables[3].list_items} />}
        </div>
        {show_buttons && buttons?.length > 0 && (
          <div className={clsx('flex justify-end space-x-48 laptop:w-full', styles.buttons)}>
            {buttons.map((button) => (
              <Button
                key={button._uid}
                {...button}
                className="w-1/8 tracking-sm"
                onClick={() => navigate(getUrl(button.url))}
              >
                {button.text}
              </Button>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}
